import { atom } from 'recoil';

// eslint-disable-next-line import/prefer-default-export
export const miniBasketActiveAtom = atom({
    key: 'miniBasketActiveAtom',
    default: false
});
